import React, { useEffect, useState } from 'react';

const HeroSection = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showWelcomeNotification, setShowWelcomeNotification] = useState(true);
  const [animationComplete, setAnimationComplete] = useState(false);
  const developerName = "Blessing Mabunda"; // Replace with your actual name
  
  useEffect(() => {
    // Start animations when component mounts
    const timer = setTimeout(() => {
      setAnimationComplete(true);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleContactClick = () => {
    setShowContactModal(true);
  };

  const closeModal = () => {
    setShowContactModal(false);
  };
  
  const closeNotification = () => {
    setShowWelcomeNotification(false);
  };

  return (
    <>
      <section className="hero-section">
        {showWelcomeNotification && (
          <div className={`welcome-notification ${animationComplete ? 'notification-slide-in' : ''}`}>
            <div className="notification-content">
              <div className="notification-icon">👋</div>
              <div className="notification-text">
                <h3>Welcome to Mabunda Tech!</h3>
                <p>I'm {developerName}, Software Developer & Founder</p>
              </div>
              <button className="close-notification" onClick={closeNotification}>
                <span className="close-icon">×</span>
              </button>
            </div>
          </div>
        )}
        
        <div className="hero-content">
          {/* Image at top with reduced bottom margin */}
          <div className={`hero-image ${animationComplete ? 'zoom-in' : ''}`}>
            <img src={require('./../../assets/me.png')} alt="Profile" />
          </div>
          
          <div className={`hero-text ${animationComplete ? 'fade-in' : ''}`}>
            <div className="hero-title">
              <h1 className="primary-text">Empowering Innovation,</h1>
              <h1 className="accent-text">One Line of Code at a Time.</h1>
            </div>
            <p className={`hero-description ${animationComplete ? 'slide-in' : ''}`}>
              Transforming ideas into innovative software solutions, empowering businesses to thrive in a digital world.
            </p>
            <div className={`hero-button-container ${animationComplete ? 'bounce-in' : ''}`}>
              <button onClick={handleContactClick}>
                Let's Build Something
                <span className="button-icon">→</span>
              </button>
            </div>
            <div className={`developer-signature ${animationComplete ? 'fade-in-delay' : ''}`}>
              <p>{developerName} - Software Developer & Founder</p>
            </div>
          </div>
        </div>
      </section>

      {showContactModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-icon pulse">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
                </svg>
              </div>
              <h3>Get in Touch</h3>
            </div>
            <p className="modal-subtitle">Choose your preferred contact method below</p>
            <div className="modal-buttons">
              <a className="modal-button whatsapp-button" href="https://wa.me/27780211698" target="_blank" rel="noopener noreferrer">
                <svg className="button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 012.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.188 8.188 0 01-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.06-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01z" />
                </svg>
                WhatsApp
              </a>
              <a className="modal-button email-button" href="mailto:blessie999@gmail.com">
                <svg className="button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
                </svg>
                Email
              </a>
              <a className="modal-button phone-button" href="tel:+27780211698">
                <svg className="button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z" />
                </svg>
                Phone
              </a>
            </div>
            <button className="close-modal" onClick={closeModal}>
              Close
              <svg className="close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .hero-section {
          background-color: white;
          padding: 40px 0;
          color: black;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          min-height: 70vh;
          position: relative;
          overflow: hidden;
        }

        .welcome-notification {
          position: fixed;
          top: 20px;
          right: -400px; /* Start off-screen */
          width: 350px;
          background: linear-gradient(to right, #003366, #0066cc);
          border-radius: 8px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
          z-index: 1000;
          transition: right 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55);
        }

        .notification-slide-in {
          right: 20px;
        }

        .notification-content {
          display: flex;
          padding: 15px;
          align-items: center;
        }

        .notification-icon {
          font-size: 24px;
          margin-right: 15px;
          background: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .notification-text {
          flex: 1;
          color: white;
        }

        .notification-text h3 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
        }

        .notification-text p {
          margin: 5px 0 0;
          font-size: 14px;
          opacity: 0.9;
        }

        .close-notification {
          background: transparent;
          border: none;
          color: white;
          cursor: pointer;
          font-size: 20px;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .close-icon {
          font-weight: bold;
          line-height: 1;
        }

        .hero-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          max-width: 1100px;
          width: 90%;
          margin: 0 auto;
        }

        .hero-text {
          width: 100%;
          text-align: center;
          opacity: 0;
          transform: translateY(20px);
          transition: all 1s ease;
          margin-top: 10px; /* Reduced from 40px to 10px */
        }

        .fade-in {
          opacity: 1;
          transform: translateY(0);
        }

        .hero-image {
          width: 100%;
          max-width: 500px;
          text-align: center;
          overflow: hidden;
          border-radius: 20px;
          box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
          opacity: 0;
          transform: scale(0.8);
          transition: all 1.2s cubic-bezier(0.17, 0.67, 0.83, 0.67);
          margin-bottom: 15px; /* Reduced from 30px to 15px */
        }

        .zoom-in {
          opacity: 1;
          transform: scale(1);
        }

        .hero-image img {
          width: 100%;
          height: auto;
          object-fit: cover;
          border-radius: 20px;
          transition: transform 0.5s ease;
        }

        .hero-image:hover img {
          transform: scale(1.03);
        }

        .hero-title {
          margin-bottom: 15px; /* Reduced from 20px to 15px */
        }

        .primary-text {
          display: block;
          font-size: 2.8rem;
          font-weight: 700;
          margin-bottom: 3px; /* Reduced from 5px to 3px */
          background: linear-gradient(to right, #000, #333);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          opacity: 0;
          animation: fadeInText 1.5s forwards;
          animation-delay: 0.5s;
        }

        .accent-text {
          display: block;
          font-size: 2.8rem;
          font-weight: 700;
          color: #0066cc;
          opacity: 0;
          animation: fadeInText 1.5s forwards;
          animation-delay: 0.8s;
        }

        .hero-description {
          font-size: 1.3rem;
          line-height: 1.6;
          margin-bottom: 20px; /* Reduced from 30px to 20px */
          color: #444;
          opacity: 0;
          transform: translateX(-20px);
          transition: all 1s ease;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        .slide-in {
          opacity: 1;
          transform: translateX(0);
        }

        .hero-button-container {
          margin-top: 20px; /* Reduced from 30px to 20px */
          opacity: 0;
          transform: translateY(20px);
          transition: all 0.8s ease;
          display: flex;
  justify-content: center;
  align-items: center; 
        }

        .bounce-in {
          opacity: 1;
          transform: translateY(0);
          animation: bounce 0.5s ease-in-out;
        }

        .hero-button-container button {
          background: linear-gradient(45deg, #00183d, #003366);
          color: white;
          padding: 15px 32px;
          border: none;
          font-size: 1.1rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 51, 102, 0.3);
          position: relative;
          overflow: hidden;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          
        }

        .button-icon {
          display: inline-block;
          margin-left: 5px;
          transition: transform 0.3s ease;
        }

        .hero-button-container button:hover .button-icon {
          transform: translateX(5px);
        }

        .hero-button-container button:before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, #0066cc, #0099ff);
          transition: all 0.4s ease;
          z-index: -1;
        }

        .hero-button-container button:hover:before {
          left: 0;
        }

        .hero-button-container button:hover {
          transform: translateY(-3px);
          box-shadow: 0 7px 20px rgba(0, 51, 102, 0.4);
        }

        .developer-signature {
          margin-top: 20px; /* Reduced from 30px to 20px */
          font-style: italic;
          color: #666;
          opacity: 0;
          transition: opacity 1s ease;
          transition-delay: 0.3s;
        }

        .developer-signature p {
          font-size: 1rem;
          margin: 0;
        }

        .fade-in-delay {
          opacity: 1;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.75);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
          animation: fadeIn 0.3s ease-out forwards;
        }

        .modal {
          background: white;
          color: #00183d;
          padding: 35px;
          border-radius: 16px;
          text-align: center;
          width: 90%;
          max-width: 420px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          opacity: 0;
          transform: scale(0.8) translateY(30px);
          animation: modalAppear 0.5s cubic-bezier(0.17, 0.67, 0.83, 0.67) forwards;
        }

        .modal-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 10px;
        }

        .modal-icon {
          background: linear-gradient(135deg, #004080, #0066cc);
          color: white;
          width: 70px;
          height: 70px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 15px;
          box-shadow: 0 10px 25px rgba(0, 102, 204, 0.3);
        }

        .pulse {
          animation: pulse 2s infinite;
        }

        .modal-header h3 {
          margin: 0;
          font-size: 1.8rem;
          font-weight: 700;
          background: linear-gradient(135deg, #003366, #0099ff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .modal-subtitle {
          color: #666;
          margin-bottom: 25px;
          font-size: 1.1rem;
        }

        .modal-buttons {
          display: flex;
          flex-direction: column;
          gap: 15px;
          margin-bottom: 25px;
        }

        .modal-button {
          background: #f5f5f5;
          color: #333;
          padding: 16px 20px;
          text-decoration: none;
          text-align: center;
          border-radius: 10px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          border: none;
          transition: all 0.3s ease;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          position: relative;
          overflow: hidden;
          z-index: 1;
        }

        .button-icon {
          flex-shrink: 0;
        }

        .whatsapp-button {
          background: #25D366;
          color: white;
        }

        .whatsapp-button:hover {
          background: #22c35e;
          transform: translateY(-3px);
          box-shadow: 0 6px 15px rgba(37, 211, 102, 0.3);
        }

        .email-button {
          background: #0066cc;
          color: white;
        }

        .email-button:hover {
          background: #0052a3;
          transform: translateY(-3px);
          box-shadow: 0 6px 15px rgba(0, 102, 204, 0.3);
        }

        .phone-button {
          background: #6200ea;
          color: white;
        }

        .phone-button:hover {
          background: #5000d6;
          transform: translateY(-3px);
          box-shadow: 0 6px 15px rgba(98, 0, 234, 0.3);
        }

        .close-modal {
          background: #f2f2f2;
          color: #444;
          padding: 14px 24px;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin: 0 auto;
        }

        .close-modal:hover {
          background: #e6e6e6;
          transform: translateY(-2px);
        }

        .close-icon {
          margin-left: 5px;
        }

        @keyframes fadeInText {
          to { opacity: 1; }
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        @keyframes modalAppear {
          from {
            opacity: 0;
            transform: scale(0.8) translateY(30px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(0, 102, 204, 0.5);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(0, 102, 204, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(0, 102, 204, 0);
          }
        }

        @media (max-width: 992px) {
          .hero-content {
            text-align: center;
          }

          .hero-image {
            max-width: 400px;
          }

          .primary-text, .accent-text {
            font-size: 2.2rem;
          }

          .welcome-notification {
            width: 90%;
            max-width: 350px;
          }
        }

        @media (max-width: 768px) {
          .hero-section {
            padding: 30px 0; /* Reduced from 40px to 30px */
          }

          .hero-image {
            max-width: 320px;
            margin-bottom: 10px; /* Reduced from 15px to 10px */
          }

          .primary-text, .accent-text {
            font-size: 1.8rem;
          }

          .hero-description {
            font-size: 1.1rem;
            margin-bottom: 15px; /* Reduced from 20px to 15px */
          }

          .hero-button-container button {
            padding: 12px 24px;
            font-size: 1rem;
          }

          .welcome-notification {
            bottom: 20px;
            top: auto;
            right: 50%;
            transform: translateX(50%);
            width: 90%;
          }

          .notification-slide-in {
            right: 50%;
          }

          .modal {
            padding: 25px;
          }

          .modal-icon {
            width: 60px;
            height: 60px;
          }

          .modal-header h3 {
            font-size: 1.6rem;
          }
        }

        @media (max-width: 480px) {
          .hero-image {
            max-width: 85%;
            margin-bottom: 8px; /* Further reduced for very small screens */
          }

          .hero-text {
            margin-top: 8px; /* Further reduced for very small screens */
          }

          .primary-text, .accent-text {
            font-size: 1.6rem;
          }
        }
      `}</style>
    </>
  );
};

export default HeroSection;